import React from 'react';
import PropTypes from 'prop-types';
import SimpleSpinner from '@Components/Results/utils/SimpleSpinner';
import Select from '@Components/Select';
import { RadioButtonGroup } from '@els/els-react--radio-button';
import { cellOperationOptionsMapping, showSubstancesOptionsMapping } from '../constants';

const mapCellOperationToOption = (cellOperation) => {
  return { label: cellOperationOptionsMapping[cellOperation], value: cellOperation };
};

const mapCellOperationToOptions = (settingsResponse) => {
  const { cellOperations } = settingsResponse;
  return cellOperations.map(mapCellOperationToOption);
};

function HeatmapSettingsDialogContent({ isLoading, settingsResponse, currentSettings, updateCurrentSetting }) {
  return (
    <section className="heatmap-settings-dialog__content">
      {isLoading ? (
        <SimpleSpinner />
      ) : (
        settingsResponse &&
        currentSettings && (
          <>
            <div className="heatmap-settings-dialog__row">
              <div className="heatmap-settings-dialog__row-label">Value of X-axis</div>
              <Select
                size="sm"
                customCssClass="heatmap-settings-dialog__row-options heatmap-settings-dialog__select"
                e2eName="heatmap-settings-value-of-x-axis"
                options={settingsResponse.cols}
                getOptionLabel={({ title }) => title}
                value={currentSettings.col}
                selectOptionHandler={(option) => updateCurrentSetting('col', option)}
              />
            </div>
            <div className="heatmap-settings-dialog__row">
              <div className="heatmap-settings-dialog__row-label">Value of Y-axis</div>
              <Select
                size="sm"
                customCssClass="heatmap-settings-dialog__row-options heatmap-settings-dialog__select"
                e2eName="heatmap-settings-value-of-y-axis"
                options={settingsResponse.rows}
                getOptionLabel={({ title }) => title}
                value={currentSettings.row}
                selectOptionHandler={(option) => updateCurrentSetting('row', option)}
              />
            </div>
            <div className="heatmap-settings-dialog__row">
              <div className="heatmap-settings-dialog__row-label">Value of Cells</div>
              <Select
                size="sm"
                customCssClass="heatmap-settings-dialog__row-options heatmap-settings-dialog__select"
                e2eName="heatmap-settings-value-of-cells"
                options={mapCellOperationToOptions(settingsResponse)}
                value={mapCellOperationToOption(currentSettings.cellOperation)}
                selectOptionHandler={(option) => updateCurrentSetting('cellOperation', option.value)}
              />
            </div>
            <div className="heatmap-settings-dialog__row">
              <div className="heatmap-settings-dialog__row-label">Show substances</div>
              <div className="heatmap-settings-dialog__row-options heatmap-settings-dialog__radio-buttons-group heatmap-settings-dialog__radio-buttons-group--vertical">
                <RadioButtonGroup.Option
                  className="heatmap-settings-dialog__radio-button"
                  onChange={() => updateCurrentSetting('showSubstances', 'names')}
                  checked={currentSettings.showSubstances === 'names'}
                  label={showSubstancesOptionsMapping.names}
                />
                <RadioButtonGroup.Option
                  className="heatmap-settings-dialog__radio-button"
                  labelClassName="heatmap-settings-dialog__radio-button-label"
                  onChange={() => updateCurrentSetting('showSubstances', 'drawing')}
                  checked={currentSettings.showSubstances === 'drawing'}
                  label={showSubstancesOptionsMapping.drawing}
                />
              </div>
            </div>
            <div className="heatmap-settings-dialog__row">
              <div className="heatmap-settings-dialog__row-label">Display mode</div>
              <div className="heatmap-settings-dialog__row-options heatmap-settings-dialog__radio-buttons-group heatmap-settings-dialog__radio-buttons-group--horizontal">
                <RadioButtonGroup.Option
                  className="heatmap-settings-dialog__radio-button"
                  onChange={() => updateCurrentSetting('startInFullScreen', false)}
                  checked={!currentSettings.startInFullScreen}
                  label="Normal"
                />
                <RadioButtonGroup.Option
                  className="heatmap-settings-dialog__radio-button"
                  labelClassName="heatmap-settings-dialog__radio-button-label"
                  onChange={() => updateCurrentSetting('startInFullScreen', true)}
                  checked={currentSettings.startInFullScreen}
                  label="Full screen"
                />
              </div>
            </div>
          </>
        )
      )}
    </section>
  );
}

HeatmapSettingsDialogContent.defaultProps = {
  updateCurrentSetting: () => {},
};

HeatmapSettingsDialogContent.propTypes = {
  isLoading: PropTypes.bool,
  settingsResponse: PropTypes.object,
  currentSettings: PropTypes.object,
  updateCurrentSetting: PropTypes.func,
};

export default HeatmapSettingsDialogContent;
